import styled from '@emotion/styled';

const StyledCheckbox = styled.div`
  display: flex;
  align-items: center;
  input[type='checkbox'] {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    appearance: none;
    -webkit-appearance: none;
    height: 20px;
    width: 20px;
    background-color: transparent;
    border: 2px solid #aab2b2;
    border-radius: 50%;
    cursor: pointer;
    outline: none;
    &:after {
      content: '';
      display: none;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #aab2b2;
    }
    &:checked {
      &:after {
        display: block;
      }
    }
  }
  label {
    cursor: pointer;
    margin-left: 10px;
    color: #aab2b2;
  }
`;

const Checkbox = () => {
  return (
    <StyledCheckbox>
      <input type='checkbox' id='checkbox' />
      <label htmlFor='checkbox' className='custom-checkbox'>
        Remember?
      </label>
    </StyledCheckbox>
  );
};

export default Checkbox;
